document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("page-modal");
  const body = document.getElementById("page-modal-body");
  const close = document.getElementById("page-modal-close");
  const overlay = document.getElementById("page-modal-overlay");

  document.querySelectorAll("[data-page-modal]").forEach(link => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      fetch(this.href)
        .then(res => res.text())
        .then(html => {
          const temp = document.createElement("div");
          temp.innerHTML = html;
          body.innerHTML = temp.querySelector("main").innerHTML;
          modal.style.display = "block";
        });
    });
  });

  close.onclick = overlay.onclick = () => {
    modal.style.display = "none";
    body.innerHTML = "";
  };
});
